import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { PartnerViewPage } from '@/components/Business/PartnerViewPage'
import {
  EMPTY_PARTNER_VIEW_SEARCH,
  type PartnerViewSearch,
  partnerViewSearchSchema,
  withoutPartnerViewDefaults,
} from '@/components/Business/partnerViewSearch'

/** Wiring only. The schema lives beside the page in `partnerViewSearch.ts`. */
export const Route = createFileRoute('/_app/business/partner-view')({
  validateSearch: partnerViewSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_PARTNER_VIEW_SEARCH)] },
  component: PartnerViewRoute,
})

function PartnerViewRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<PartnerViewSearch>) =>
      void navigate({
        search: (current) => withoutPartnerViewDefaults({ ...current, ...next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  )
  return <PartnerViewPage search={search} onSearchChange={onSearchChange} />
}
